// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Print preview: a browser-renderable equivalent of the backend-oms PDF export template (A4).
   Uses the shared foundation tokens from ./tokens/tokens.css. See "JoPath · Web Platform" PM board,
   "15/16 · Print preview" frames. */

.pp-shell {
  min-height: 100vh;
  background: var(--secondary, #f3f4f6);
  padding: 24px 0 40px;
}

.pp-shell--center {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted-foreground, #4b5563);
  font-family: var(--font-sans, 'Inter', sans-serif);
}

.pp-toolbar {
  max-width: 820px;
  margin: 0 auto 12px;
  padding: 0 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.pp-lang {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  margin-inline-end: auto;
  background: var(--secondary, #f3f4f6);
  border-radius: var(--radius-md, 8px);
}

.pp-lang__btn {
  min-width: 32px;
  min-height: 32px;
  padding: 0.25rem 0.6rem;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--muted-foreground, #4b5563);
  font-weight: 600;
  font-size: var(--text-body-sm, 13px);
  cursor: pointer;
}

.pp-lang__btn.is-active {
  background: var(--card, #fff);
  color: var(--foreground, #111928);
  box-shadow: 0 1px 2px var(--shadow-color-soft, rgba(16, 24, 40, 0.06));
}

.pp-page {
  max-width: 820px;
  margin: 0 auto;
  background: var(--card, #fff);
  color: var(--foreground, #111928);
  font-family: var(--font-sans, 'Inter', 'IBM Plex Sans Arabic', sans-serif);
  font-size: var(--text-caption, 12px);
  line-height: var(--text-caption--line-height, 16px);
  padding: 40px;
  box-shadow: var(--shadow-lg, 0 12px 32px rgba(17, 24, 39, 0.18));
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pp-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--foreground, #111928);
}

.pp-brand {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.pp-logo {
  font-family: var(--font-sans, 'Inter', sans-serif);
  font-weight: 700;
  font-size: 28px;
  color: var(--primary-text, #6b1d1d);
  letter-spacing: -0.5px;
}

.pp-project {
  font-weight: 500;
  font-size: var(--text-body-sm, 13px);
}

.pp-muted {
  color: var(--muted-foreground, #4b5563);
}

.pp-report-meta {
  text-align: end;
}

.pp-h3 {
  font-weight: 600;
  font-size: var(--text-h3, 18px);
}

.pp-mono {
  font-family: var(--font-mono, 'JetBrains Mono', monospace);
}

.pp-info {
  border-top: 1px solid var(--border-strong, #888f9c);
  border-inline-start: 1px solid var(--border-strong, #888f9c);
}

.pp-row {
  display: flex;
}

.pp-cell {
  flex: 1 0;
  min-width: 0;
  padding: 4px 8px;
  border-bottom: 1px solid var(--border-strong, #888f9c);
  border-inline-end: 1px solid var(--border-strong, #888f9c);
}

.pp-cell--header,
.pp-cell--total {
  background: var(--secondary, #f3f4f6);
  font-weight: 500;
}

.pp-row--total .pp-cell {
  background: var(--secondary, #f3f4f6);
  font-weight: 500;
}

.pp-cell--end {
  text-align: end;
}

.pp-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pp-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
  border-bottom: 2px solid var(--foreground, #111928);
}

.pp-section-title p {
  flex: 1 0;
  font-weight: 500;
  font-size: var(--text-label, 14px);
  margin: 0;
}

.pp-section-title span {
  color: var(--muted-foreground, #4b5563);
  white-space: nowrap;
}

.pp-table {
  border-top: 1px solid var(--border-strong, #888f9c);
  border-inline-start: 1px solid var(--border-strong, #888f9c);
}

.pp-row--head .pp-cell {
  background: var(--secondary, #f3f4f6);
  font-weight: 500;
}

.pp-photos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.pp-photo p {
  margin: 4px 0 0;
}

.pp-photo__frame {
  height: 100px;
  border: 1px solid var(--border-strong, #888f9c);
  overflow: hidden;
}

.pp-photo__frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pp-notes {
  border: 1px solid var(--border-strong, #888f9c);
  padding: 8px;
}

.pp-notes p {
  margin: 0 0 4px;
}

.pp-notes p:last-child {
  margin-bottom: 0;
}

.pp-signatures {
  display: flex;
  gap: 24px;
}

.pp-signature {
  flex: 1 0;
  border: 1px solid var(--border-strong, #888f9c);
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pp-signature__name {
  font-weight: 500;
  font-size: var(--text-body-sm, 13px);
}

.pp-footer {
  border-top: 1px solid var(--border-strong, #888f9c);
  padding-top: 8px;
  color: var(--muted-foreground, #4b5563);
}

.pp-break-before {
  page-break-before: always;
  break-before: page;
}

@media print {
  .pp-shell {
    background: none;
    padding: 0;
  }

  .pp-toolbar {
    display: none;
  }

  .pp-page {
    box-shadow: none;
    max-width: none;
    padding: 0;
  }

  @page {
    size: A4;
    margin: 16mm;
  }

  .pp-section,
  .pp-row,
  .pp-signature {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA;;oCAEoC;;AAEpC;EACE,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,uCAAuC;EACvC,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,sEAAsE;AACxE;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iCAAiC;EACjC,0EAA0E;EAC1E,oCAAoC;EACpC,mDAAmD;EACnD,aAAa;EACb,gEAAgE;EAChE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,mDAAmD;EACnD,4DAA4D;AAC9D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sDAAsD;EACtD,0DAA0D;AAC5D;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,4DAA4D;AAC9D;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAW;EACX,+CAA+C;EAC/C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,yBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;;;IAGE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":["/* Print preview: a browser-renderable equivalent of the backend-oms PDF export template (A4).\r\n   Uses the shared foundation tokens from ./tokens/tokens.css. See \"JoPath · Web Platform\" PM board,\r\n   \"15/16 · Print preview\" frames. */\r\n\r\n.pp-shell {\r\n  min-height: 100vh;\r\n  background: var(--secondary, #f3f4f6);\r\n  padding: 24px 0 40px;\r\n}\r\n\r\n.pp-shell--center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--muted-foreground, #4b5563);\r\n  font-family: var(--font-sans, 'Inter', sans-serif);\r\n}\r\n\r\n.pp-toolbar {\r\n  max-width: 820px;\r\n  margin: 0 auto 12px;\r\n  padding: 0 16px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.pp-lang {\r\n  display: inline-flex;\r\n  gap: 2px;\r\n  padding: 2px;\r\n  margin-inline-end: auto;\r\n  background: var(--secondary, #f3f4f6);\r\n  border-radius: var(--radius-md, 8px);\r\n}\r\n\r\n.pp-lang__btn {\r\n  min-width: 32px;\r\n  min-height: 32px;\r\n  padding: 0.25rem 0.6rem;\r\n  border: 0;\r\n  border-radius: var(--radius-sm, 6px);\r\n  background: transparent;\r\n  color: var(--muted-foreground, #4b5563);\r\n  font-weight: 600;\r\n  font-size: var(--text-body-sm, 13px);\r\n  cursor: pointer;\r\n}\r\n\r\n.pp-lang__btn.is-active {\r\n  background: var(--card, #fff);\r\n  color: var(--foreground, #111928);\r\n  box-shadow: 0 1px 2px var(--shadow-color-soft, rgba(16, 24, 40, 0.06));\r\n}\r\n\r\n.pp-page {\r\n  max-width: 820px;\r\n  margin: 0 auto;\r\n  background: var(--card, #fff);\r\n  color: var(--foreground, #111928);\r\n  font-family: var(--font-sans, 'Inter', 'IBM Plex Sans Arabic', sans-serif);\r\n  font-size: var(--text-caption, 12px);\r\n  line-height: var(--text-caption--line-height, 16px);\r\n  padding: 40px;\r\n  box-shadow: var(--shadow-lg, 0 12px 32px rgba(17, 24, 39, 0.18));\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.pp-header {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 2px solid var(--foreground, #111928);\r\n}\r\n\r\n.pp-brand {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.pp-logo {\r\n  font-family: var(--font-sans, 'Inter', sans-serif);\r\n  font-weight: 700;\r\n  font-size: 28px;\r\n  color: var(--primary-text, #6b1d1d);\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.pp-project {\r\n  font-weight: 500;\r\n  font-size: var(--text-body-sm, 13px);\r\n}\r\n\r\n.pp-muted {\r\n  color: var(--muted-foreground, #4b5563);\r\n}\r\n\r\n.pp-report-meta {\r\n  text-align: end;\r\n}\r\n\r\n.pp-h3 {\r\n  font-weight: 600;\r\n  font-size: var(--text-h3, 18px);\r\n}\r\n\r\n.pp-mono {\r\n  font-family: var(--font-mono, 'JetBrains Mono', monospace);\r\n}\r\n\r\n.pp-info {\r\n  border-top: 1px solid var(--border-strong, #888f9c);\r\n  border-inline-start: 1px solid var(--border-strong, #888f9c);\r\n}\r\n\r\n.pp-row {\r\n  display: flex;\r\n}\r\n\r\n.pp-cell {\r\n  flex: 1 0 0;\r\n  min-width: 0;\r\n  padding: 4px 8px;\r\n  border-bottom: 1px solid var(--border-strong, #888f9c);\r\n  border-inline-end: 1px solid var(--border-strong, #888f9c);\r\n}\r\n\r\n.pp-cell--header,\r\n.pp-cell--total {\r\n  background: var(--secondary, #f3f4f6);\r\n  font-weight: 500;\r\n}\r\n\r\n.pp-row--total .pp-cell {\r\n  background: var(--secondary, #f3f4f6);\r\n  font-weight: 500;\r\n}\r\n\r\n.pp-cell--end {\r\n  text-align: end;\r\n}\r\n\r\n.pp-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.pp-section-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding-bottom: 4px;\r\n  border-bottom: 2px solid var(--foreground, #111928);\r\n}\r\n\r\n.pp-section-title p {\r\n  flex: 1 0 0;\r\n  font-weight: 500;\r\n  font-size: var(--text-label, 14px);\r\n  margin: 0;\r\n}\r\n\r\n.pp-section-title span {\r\n  color: var(--muted-foreground, #4b5563);\r\n  white-space: nowrap;\r\n}\r\n\r\n.pp-table {\r\n  border-top: 1px solid var(--border-strong, #888f9c);\r\n  border-inline-start: 1px solid var(--border-strong, #888f9c);\r\n}\r\n\r\n.pp-row--head .pp-cell {\r\n  background: var(--secondary, #f3f4f6);\r\n  font-weight: 500;\r\n}\r\n\r\n.pp-photos {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n}\r\n\r\n.pp-photo p {\r\n  margin: 4px 0 0;\r\n}\r\n\r\n.pp-photo__frame {\r\n  height: 100px;\r\n  border: 1px solid var(--border-strong, #888f9c);\r\n  overflow: hidden;\r\n}\r\n\r\n.pp-photo__frame img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.pp-notes {\r\n  border: 1px solid var(--border-strong, #888f9c);\r\n  padding: 8px;\r\n}\r\n\r\n.pp-notes p {\r\n  margin: 0 0 4px;\r\n}\r\n\r\n.pp-notes p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.pp-signatures {\r\n  display: flex;\r\n  gap: 24px;\r\n}\r\n\r\n.pp-signature {\r\n  flex: 1 0 0;\r\n  border: 1px solid var(--border-strong, #888f9c);\r\n  padding: 8px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.pp-signature__name {\r\n  font-weight: 500;\r\n  font-size: var(--text-body-sm, 13px);\r\n}\r\n\r\n.pp-footer {\r\n  border-top: 1px solid var(--border-strong, #888f9c);\r\n  padding-top: 8px;\r\n  color: var(--muted-foreground, #4b5563);\r\n}\r\n\r\n.pp-break-before {\r\n  break-before: page;\r\n}\r\n\r\n@media print {\r\n  .pp-shell {\r\n    background: none;\r\n    padding: 0;\r\n  }\r\n\r\n  .pp-toolbar {\r\n    display: none;\r\n  }\r\n\r\n  .pp-page {\r\n    box-shadow: none;\r\n    max-width: none;\r\n    padding: 0;\r\n  }\r\n\r\n  @page {\r\n    size: A4;\r\n    margin: 16mm;\r\n  }\r\n\r\n  .pp-section,\r\n  .pp-row,\r\n  .pp-signature {\r\n    break-inside: avoid;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
